// Company social profiles. The API's contact record holds bare instagram.com / facebook.com URLs,
// so the site links these instead. Empty string = icon hidden.
export const INSTAGRAM = "https://www.instagram.com/leaderautoship_/";
export const FACEBOOK = "https://www.facebook.com/profile.php?id=61570680844168";
